// Updated labels for Condo only

const labels = {
  GarageNumberOfCars: "Places de parking",
}

export default labels;
